var _rect, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTimepicker(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1,
    y: 6,
    width: 22,
    height: 12,
    rx: 2,
    stroke: "#0973F8",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.9974 13.2437C13.8341 12.8494 13.75 12.4268 13.75 12C13.75 11.138 14.0924 10.3114 14.7019 9.7019C15.3114 9.09241 16.138 8.75 17 8.75C17.862 8.75 18.6886 9.09241 19.2981 9.7019C19.9076 10.3114 20.25 11.138 20.25 12C20.25 12.4268 20.1659 12.8494 20.0026 13.2437C19.8393 13.638 19.5999 13.9963 19.2981 14.2981C18.9963 14.5999 18.638 14.8393 18.2437 15.0026C17.8494 15.1659 17.4268 15.25 17 15.25C16.5732 15.25 16.1506 15.1659 15.7563 15.0026C15.362 14.8393 15.0037 14.5999 14.7019 14.2981C14.4001 13.9963 14.1607 13.638 13.9974 13.2437Z",
    stroke: "#00AEEE",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 10.5L16 11.875L18 13",
    stroke: "#00AEEE",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimepicker);
export default __webpack_public_path__ + "static/media/timepicker.6626a0f3.svg";
export { ForwardRef as ReactComponent };